const vm = {
    "vm.title.block1": "Filter",
    "vm.title.block2": "ลองเลนส์",
    "vm.defineClassic": "Define® Classic",
    "vm.defineFresh": "Define® Fresh",
    "vm.learnmore": "เรียนรู้เพิ่มเติม",
    "vm.shownow": "สั่งซื้อ",
}

export default vm;